import { Box, SxProps, Theme } from '@mui/material'
import { HighlightedTextWrapper } from './highlighted-text.styled'

interface IProps {
  text: string
  fontSize?: string | number
  fontWeight?: number | string
  fontFamily?: string
  backgroundColor?: string
  color?: string
  sx?: SxProps<Theme>
}

export const HighlightedText = ({
  text,
  fontSize = 'inherit',
  fontWeight = 600,
  fontFamily,
  backgroundColor = '#FFFFFF',
  color = '#000000',
  sx,
}: IProps) => {
  return (
    <Box
      id="index__components-highlighted-text__box__l42"
      sx={{
        display: 'inline-block',
        fontFamily,
        maxWidth: '100%',
        ...sx,
      }}
    >
      <HighlightedTextWrapper
        id="index__components-highlighted-text__highlightedtextwrapper__l33"
        sx={{
          fontSize: fontSize || 'inherit',
          fontWeight,
          fontFamily,
          color,
          backgroundColor,
        }}
      >
        {text}
      </HighlightedTextWrapper>
    </Box>
  )
}
